import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const LinkedInIconSolidCircular = () => (
  <SVGUniqueID>
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 5.37263 5.37263 6.96257e-06 12 6.96257e-06C18.6274 6.96257e-06 24 5.37263 24 12Z"
        fill="#4467AD"
      />
      <path
        d="M12.9264 10.3627C13.1236 10.1414 13.2859 9.91648 13.4884 9.72572C14.1108 9.13923 14.8468 8.84323 15.7062 8.85052C16.1785 8.85443 16.6456 8.88856 17.1009 9.0203C18.1425 9.32145 18.7478 10.0384 19.0363 11.0559C19.2528 11.8189 19.2927 12.6023 19.2941 13.3881C19.2969 15.0459 19.2893 16.7035 19.2929 18.3613C19.2932 18.5165 19.2498 18.5572 19.0969 18.5558C18.2431 18.5488 17.3889 18.5487 16.535 18.5561C16.3848 18.5574 16.3522 18.5108 16.3528 18.3689C16.3576 16.7915 16.3586 15.2143 16.3537 13.6368C16.3522 13.2416 16.3272 12.8466 16.2162 12.4623C16.012 11.7543 15.5053 11.3936 14.7636 11.4327C13.7508 11.4863 13.2242 11.9878 13.0952 13.0174C13.0642 13.2635 13.0497 13.5095 13.0498 13.7574C13.0513 15.2914 13.0482 16.8253 13.0539 18.3593C13.0544 18.5124 13.0162 18.5575 12.86 18.5561C11.9999 18.5485 11.1396 18.5494 10.2793 18.5554C10.1416 18.5565 10.1016 18.5193 10.1017 18.3799C10.1057 15.3428 10.1057 12.3056 10.1016 9.26847C10.1014 9.11825 10.1506 9.08341 10.2927 9.08447C11.1096 9.09052 11.9266 9.09123 12.7433 9.08394C12.8937 9.0827 12.9325 9.13123 12.9291 9.27363C12.9208 9.63648 12.9264 9.99967 12.9264 10.3627Z"
        fill="#FEFEFE"
      />
      <path
        d="M8.24798 13.8336C8.24798 15.336 8.24549 16.8385 8.25154 18.3411C8.25225 18.5081 8.21065 18.5585 8.03785 18.5566C7.18434 18.5472 6.33047 18.5495 5.47678 18.5553C5.34007 18.5564 5.29883 18.5221 5.29883 18.3808C5.30309 15.3386 5.30274 12.2965 5.29971 9.25437C5.29954 9.1285 5.33011 9.0837 5.4638 9.08441C6.32976 9.0901 7.19589 9.0917 8.06185 9.08352C8.22825 9.08175 8.25101 9.14646 8.25065 9.28904C8.24656 10.8039 8.24798 12.3187 8.24798 13.8336Z"
        fill="#FEFEFE"
      />
      <path
        d="M8.48454 6.06987C8.48525 7.01333 7.71974 7.78187 6.77859 7.78223C5.84934 7.78258 5.07725 7.01333 5.07423 6.08462C5.07103 5.14578 5.84276 4.37262 6.78196 4.37351C7.71476 4.3744 8.48347 5.14044 8.48454 6.06987Z"
        fill="#FEFEFE"
      />
    </svg>
  </SVGUniqueID>
);
export { LinkedInIconSolidCircular };
